import React from "react";
import {Grid, TextField, MenuItem, Typography, useTheme, Button} from "@material-ui/core";
import {notEmpty} from "../../../helpers/Validator";
import Rest from "../../../helpers/Rest";
import {Person} from "@material-ui/icons";
import useStyles from "./styles"

const DEFAULT_DETAILS_KEY = "PDU_SIGN_IN_DETAILS"

function testPhone(val){
    return /[\d]{6,}/.test(val.replace(/[\s+\-]+/g, ''))
}

const NAME_FIELD = ["Your Full Name", "name", notEmpty], PHONE_FIELD = ["Contact Phone Number", "phone", testPhone],
    COMPANY_FIELD = ["Company", "company", notEmpty], EMPLOYEE_NUMBER_FIELD = ["Employee Number", "employee_number", notEmpty]

const SEND_FIELDS = [NAME_FIELD, PHONE_FIELD, COMPANY_FIELD, EMPLOYEE_NUMBER_FIELD]

const FIELD_MAP = {
    visitor: [NAME_FIELD, PHONE_FIELD, [COMPANY_FIELD[0], COMPANY_FIELD[1]]],
    contractor: [NAME_FIELD, PHONE_FIELD, COMPANY_FIELD],
    employee: [EMPLOYEE_NUMBER_FIELD]
}

class SignIn extends React.Component{
    constructor(props) {
        super(props);
        this.state = this.getDefaults()
        this.props.onInitialized(this.signIn.bind(this), this.valid)
    }

    get valid(){
        return !this.fields.find(([, name, validate]) => validate && !validate(this.state[name] || ''))
    }

    serializeState(){
        const {reason} = this.state
        const allowed = new Set(FIELD_MAP[reason].map(([,field]) => field))
        return SEND_FIELDS.reduce((out, [,field]) => {
            out[field] = (allowed.has(field) && this.state[field]) || ''
            return out
        }, {
            reason: reason,
            address: ''
        })
    }

    getDefaults(){
        let details = window.localStorage.getItem(DEFAULT_DETAILS_KEY)
        if (details){
            details = JSON.parse(details)
            if (details.reason && FIELD_MAP[details.reason]){
                return details
            }
        }
        return {
            reason: 'employee'
        }
    }

    saveState(state){
        window.localStorage.setItem(DEFAULT_DETAILS_KEY, JSON.stringify(state))
    }

    get fields(){
        return FIELD_MAP[this.state.reason]
    }

    checkValidation() {
        this.props.onValidationStateChanged(this.valid)
    }

    setField(name, value){
        this.setState({[name]: value})
        this.checkValidation()
    }

    addField(name, prop, validate){
        const blurKey = `${prop}Blurred`
        const value = this.state[prop] || ''
        return <Grid item xs={12} key={prop}>
                <TextField
                    variant="outlined"
                    value={value}
                    onChange={(e) => this.setField(prop, e.target.value)}
                    label={name}
                    error={this.state[blurKey] && validate && !validate(value)}
                    helperText={validate ? undefined : 'Optional'}
                    onBlur={() => {
                        this.setState({
                            [blurKey]: true
                        })
                    }}
                    fullWidth
                />
            </Grid>
    }

    signIn(){
        const state = this.serializeState()
        return Rest.post(`registration/${this.props.qrCode}`, state).then(reply => {
            this.saveState(state)
            return reply.id
        })
    }

    render(){
        const {reason} = this.state
        const fields = FIELD_MAP[reason]

        return <Grid container spacing={2}>
                    <Grid item container xs={12} className={this.props.classes.heading}>
                        <Person color="disabled"/>
                        <Typography variant="h5">
                            Please Sign In
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            value={reason}
                            onChange={e => this.setState({reason: e.target.value})}
                            label="Reason for visit"
                            select fullWidth
                        >
                            <MenuItem key="visitor" value="visitor">
                                Visitor
                            </MenuItem>
                            <MenuItem key="contractor" value="contractor">
                                Contractor
                            </MenuItem>
                            <MenuItem key="employee" value="employee">
                                Employee
                            </MenuItem>
                        </TextField>
                    </Grid>
                    {fields.map(([label, prop, validate]) => this.addField(label, prop, validate))}
                    <Grid item container xs={12} justify="center" alignItems="center">
                        <Button
                            variant="text"
                            color="primary"
                            onClick={() => window.alert("TODO")}
                            className={this.props.classes.privacyLink}
                        >
                            View Privacy Policy
                        </Button>
                    </Grid>
                </Grid>
    }
}

export default function(props){
    const classes = useStyles(useTheme())
    return <SignIn classes={classes} {...props}/>
}
